import { get, post } from "../axios";

// 系统日志-列表
export const logList = (params) => get("/web/system/log/list", params);

// 系统日志-清空

export const logView = (id) => get("/web/system/log/view/" + id);
